export enum MessageType {
    Unknown,
    System,
    Mouse,
    Bounds,
}

export class Message {
    constructor(value: any = null) {
        if (value) {
            this.sender = value.sender;
            this.type = value.type;
            this.data = value.data;
        }
    }

    sender: string;
    type: MessageType = MessageType.Unknown;
    data: any = null;
}